import { House, Gear, List, People, ClockHistory  } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const SideBar = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const navItems = [
    { label: "Dashboard", icon: <House size={18} />, path: "/dashboard" },
    { label: "Nuevo Sorteo", icon: <Gear size={18} />, path: "/config" },
    { label: "Historial", icon: <ClockHistory size={18} />, path: "/historial" },
    { label: "Usuarios", icon: <People size={18} />, path: "/usuarios" },
  ];

  return (
    <>
      {/* Botón hamburguesa arriba a la izquierda solo en mobile */}
      <div className="d-md-none position-fixed top-0 start-0 p-2 z-3">
        <button className="btn btn-outline-secondary" onClick={() => setOpen(!open)}>
          <List size={20} />
        </button>
      </div>

      {/* Overlay para cerrar al hacer clic fuera */}
      {open && (
        <div
          className="sidebar-overlay"
          onClick={() => setOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div className={`sidebar-container ${open ? "show" : ""}`}>
        <div className="sidebar-content">
          <div className="d-flex align-items-center p-3 border-bottom">
            {/* <img src="/logo192.png" alt="logo" style={{ width: "30px" }} /> */}
            <span className="ms-2 fw-bold">Chriis Store</span>
          </div>
          <ul className="list-unstyled m-0 p-3">
            {navItems.map((item, index) => (
              <li
                key={index}
                onClick={() => {
                  navigate(item.path);
                  setOpen(false);
                }}
                className="d-flex align-items-center gap-2 py-2 px-2 sidebar-link"
                style={{ cursor: "pointer", borderRadius: "6px" }}
              >
                {item.icon}
                <span>{item.label}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default SideBar;
